<template>
  <div>
    <LargeNotice
      v-if="error && error.type === 'TOKEN_EXPIRED'"
      v-on:click="sendEmail"
      icon="😢"
      :title="this.$t('error.title')"
      :subtitle="this.$t('email-confirmation.expired-link')"
      :buttonText="this.$t('email-confirmation.resend-email')"
    />
    <LargeNotice
      v-else-if="error && error.type === 'TOKEN_ALREADY_USED'"
      v-on:click="redirect"
      icon="🤔"
      :title="this.$t('error.title')"
      :subtitle="$t('email-confirmation.link-already-used')"
      :buttonText="this.$t('invite.go-to-login')"
      :buttonIcon="'arrow-right'"
    />
    <BaseError v-else :error="error" />
  </div>
</template>

<script>
import BaseError from '@/components/base/BaseError';
import LargeNotice from '@/components/notice/LargeNotice';
import { paths } from '@/util/paths';

export default {
  components: {
    BaseError,
    LargeNotice,
  },
  props: {
    error: Object,
  },
  methods: {
    sendEmail() {
      this.$emit('send-new-email');
    },
    redirect() {
      this.$router.push(paths.login);
    },
  },
};
</script>

<style lang="scss"></style>
